import React from 'react';
import CookieConsent, { CookieConsentProps, } from 'react-cookie-consent';
import IconButton from '@material-ui/core/IconButton';
import CancelSharpIcon from '@material-ui/icons/CancelSharp';
import Link from '@material-ui/core/Link';

import { layout, utils, } from 'styles';
import { DEVELOPMENT, } from 'common/constants';
import CookieInfoDialog from 'common/components/CookieInfoDialog';
import { buttercup, } from 'styles/abstract/variables';

const AcceptButton = (props: CookieConsentProps) => {
    const { button, } = layout.makeCookiePanelStyles();

    return (
        <IconButton {...props}
                    classes={{ root: button, }}
                    style={{ color: buttercup, }}>
            <CancelSharpIcon />
        </IconButton>
    );
};

const enableDebugWhenDev = process.env.NODE_ENV === DEVELOPMENT;

const CookiePanel = () => {
    const { container, infoLinkLabel, } = layout.makeCookiePanelStyles();
    const pointerStyles = utils.makePointerStyles();

    return (
        <CookieConsent disableStyles
                       debug={enableDebugWhenDev}
                       containerClasses={container}
                       ButtonComponent={AcceptButton}>
            Ta strona używa plików cookies.{' '}
            <CookieInfoDialog>
                {({ handleClickOpen, }) => <Link onClick={handleClickOpen}
                                                 classes={pointerStyles}
                                                 color="inherit">
                    <span className={infoLinkLabel}>Dowiedz się więcej</span>
                </Link>}
            </CookieInfoDialog>
        </CookieConsent>
    );
};

export default CookiePanel;
